export enum StatusEventTypeDescription {
  FAILURE = 'danger',
  WARNING = 'warning',
  INFO = 'info',
  DEBUG = 'debug',
  INHIBIT = 'inhibit',
  UNSUPPORTED = '',
  UNDEFINED = ''
}